import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useNodeEnv = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  const rmwTools = React.useMemo(() => {
    return environment.nodeEnv;
  }, [environment.nodeEnv]);

  return rmwTools;
};
